var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9012 4.90234H7.9001C6.13229 4.90234 4.69922 6.33542 4.69922 8.10323C4.69922 9.87103 6.13229 11.3041 7.9001 11.3041H14.3019C16.0697 11.3041 17.5027 9.87103 17.5027 8.10323C17.5027 7.29144 17.2005 6.55024 16.7025 5.986",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.30022 7.01342C1.80219 6.44918 1.5 5.70798 1.5 4.89619C1.5 3.12839 2.93308 1.69531 4.70088 1.69531H11.1026C12.8705 1.69531 14.3035 3.12839 14.3035 4.89619C14.3035 6.664 12.8705 8.09708 11.1026 8.09708H7.10154",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/Icon_link.73d301f6d352b07a8d07aab78383d68c.svg";
export { ForwardRef as ReactComponent };